import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Confirm,
  useDataProvider,
  useNotify,
  useResourceContext,
  useTranslate,
} from "react-admin";
import { useMutation } from "react-query";
import ReasonForm from "./reason/Form";
import PrintMyIcon from "../myIcons/PrintMyIcon";

const PrintBtn = ({
  recordId,
  setPrintRecord,
  setResetPrintContent,
  ...props
}) => {
  const resource = useResourceContext();
  const printFormId = `delivery-note:${recordId}`;
  const [open, setOpen] = useState(false);
  const [reasonForm, setReasonForm] = useState();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const t = useTranslate();

  const { mutate, data, isLoading, error, reset, status } = useMutation(
    (formDataReason) => {
      return dataProvider.simplePost(
        resource + "/print/" + encodeURIComponent(recordId),
        { data: formDataReason }
      );
    }
  );

  useEffect(() => {
    if (status === "success" || status === "error") {
      setResetPrintContent(() => reset);
    }
  }, [status]);

  useEffect(() => {
    if (error) {
      notify("mine.notification." + error.message.split(" ").join("_"), {
        type: "error",
      });
    }
  }, [error]);

  useEffect(() => {
    // Ignore the previous mutation response while a new request is loading.
    // Without this guard, closing the reason form caused the old
    // print_history_id response to reset the newly returned print content.
    if (!data || status !== "success") return;

    if (data.print_history_id && open) {
      setReasonForm(data);
      setPrintRecord({});
      return;
    }

    if (data.id) {
      // Both the first print and an approved repeat print return print data.
      setPrintRecord(data);
      setReasonForm(undefined);
      setOpen(false);
    }
  }, [data, open, status]);

  const handleClick = (e) => {
    e.stopPropagation();
    setOpen(true);
  };
  const handleDialogClose = () => {
    setOpen(false);
    setReasonForm(undefined);
    setPrintRecord({});
    reset();
  };

  const handleConfirm = () => {
    if (status === "idle") {
      // masuk sini artinya ini klik confirm pertama
      mutate();
    } else {
      // masuk sini artinya ini klik confirm kedua
      // SUBMIT FORM
      var clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      const submitButton = Array.from(
        document.querySelectorAll("button.sbt-btn-rsn")
      ).find((button) => button.dataset.printFormId === printFormId);

      if (submitButton) {
        submitButton.dispatchEvent(clickEvent);
      }
      // SUBMIT FORM
    }
  };

  const save = useCallback((values) => {
    // Keep the pending history id even if the form library omits the
    // visually hidden input from submitted values.
    mutate({
      ...values,
      print_history_id: values.print_history_id || reasonForm?.print_history_id,
    });
    setOpen(false);
  }, [mutate, reasonForm]);

  return (
    <>
      <Button
        label="Print"
        disabled={isLoading}
        variant="outlined"
        startIcon={<PrintMyIcon />}
        sx={{
          mx: 1,
          "& > .MuiButton-startIcon": {
            // mr: 0,
          },
        }}
        {...props.btnProps}
        onClick={handleClick}
      />
      <Confirm
        isOpen={open}
        loading={isLoading}
        title={t("mine.dialog.print_delivery_note")}
        content={
          reasonForm ? (
            <ReasonForm
              reasonForm={reasonForm}
              save={save}
              formId={printFormId}
            />
          ) : (
            "mine.message.print_content"
          )
        }
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
        sx={reasonForm ? { "& .MuiDialogContent-root": { pb: 0 } } : undefined}
        {...props.dialogProps}
      />
    </>
  );
};

export default PrintBtn;
